import script from "./SampleView.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleView.vue?vue&type=script&setup=true&lang=js"

import "./SampleView.vue?vue&type=style&index=0&id=0a1c1e6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1c1e6f"]])

export default __exports__